export const VISITOR_PICKUP_DEFAULTS = {
    enabled: true,
    maxCards: 3,
    dateWindowDays: 7,
    cancelCutoffMins: 60,
    centers: [],
};

const isTruthyFlag = (value, fallback = false) => {
    if (value === true) return true;
    if (value === false) return false;
    if (typeof value === 'string' && value.toLowerCase() === 'true') return true;
    if (typeof value === 'string' && value.toLowerCase() === 'false') return false;
    return fallback;
};

const toPositiveInt = (value, fallback) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
    return Math.floor(parsed);
};

const toNonNegativeInt = (value, fallback) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) return fallback;
    return Math.floor(parsed);
};

const normalizeCenters = (value) => {
    if (!Array.isArray(value)) return [];
    return value
        .map((item) => {
            if (!item || typeof item !== 'object' || Array.isArray(item)) return null;
            const centerId = item.center_id ?? item.centerId ?? item.Center_Id;
            if (centerId == null || String(centerId).trim() === '') return null;
            return {
                center_id: String(centerId).trim(),
                name: String(item.name ?? item.center_name ?? item.Center_Name ?? '').trim(),
            };
        })
        .filter(Boolean);
};

export const getVisitorPickupConfig = (constants = {}) => ({
    enabled: isTruthyFlag(constants.VISITOR_PICKUP_ENABLED, VISITOR_PICKUP_DEFAULTS.enabled),
    maxCards: toPositiveInt(constants.VISITOR_PICKUP_MAX_CARDS, VISITOR_PICKUP_DEFAULTS.maxCards),
    dateWindowDays: toPositiveInt(
        constants.VISITOR_PICKUP_DATE_WINDOW_DAYS,
        VISITOR_PICKUP_DEFAULTS.dateWindowDays
    ),
    cancelCutoffMins: toNonNegativeInt(
        constants.VISITOR_PICKUP_CANCEL_CUTOFF_MINS,
        VISITOR_PICKUP_DEFAULTS.cancelCutoffMins
    ),
    centers: normalizeCenters(constants.VISITOR_PICKUP_CENTERS),
});

export const isVisitorPickupVisibleForCenter = (constants = {}, centerId) => {
    const { enabled, centers } = getVisitorPickupConfig(constants);
    if (!enabled) return false;
    if (centers.length === 0) return true;
    const id = centerId == null ? '' : String(centerId).trim();
    if (!id) return false;
    return centers.some((center) => center.center_id === id);
};
